export { projectInfo };
import { getGlobalObject } from './getGlobalObject';
import { PROJECT_VERSION } from './PROJECT_VERSION';
const projectInfo = {
    projectName: 'react-streaming',
    projectVersion: PROJECT_VERSION,
    npmPackageName: 'react-streaming',
    githubRepository: 'https://github.com/brillout/react-streaming',
};
const { versions } = getGlobalObject('projectInfo.ts', {
    versions: new Set(),
});
versions.add(projectInfo.projectVersion);
if (versions.size >= 2) {
    const versionsStr = Array.from(versions)
        .map((v) => `${projectInfo.projectName}@${v}`)
        .join(' and ');
    throw new Error(`${versionsStr} loaded but loading different versions is forbidden`);
}
